export default __webpack_public_path__ + "static/media/products.8fd83aef.png";